import { useContext, useMemo } from "react";
import { ANONYMOUS_VIEWER, type PriceViewer } from "@nh/shared";
import { AuthContext } from "@/features/auth/auth.contextValue";

/**
 * Quién está mirando la tienda, reducido a lo que decide el precio
 * (`viewerPriceCents` en `@nh/shared`): si hay sesión y si tiene
 * franquicia.
 *
 * Lee el contexto directo y NO con `useAuth`: la tarjeta de producto se
 * monta también en pruebas y vitrinas sin `<AuthProvider>`, y ahí lo
 * correcto es "anónimo", no reventar. Con sesión cargando también es
 * anónimo un instante; la tarjeta se repinta sola al resolverse.
 */
export function usePriceViewer(): PriceViewer {
  const auth = useContext(AuthContext);
  const user = auth?.user ?? null;
  return useMemo(
    () => (user ? { isSignedIn: true, isFranchisee: Boolean(user.franchiseeSince) } : ANONYMOUS_VIEWER),
    [user],
  );
}
